import './index.scss';

import DisplayQueue from '@pch/display-queue-js';

import PySerp from '@pch/serp';

import 'risk-management';
import 'prize-machine';
import 'uninav-integration';

import DisplayableFactory from 'displayable/factory';
import 'system1-suggester';
import decorateSearchBars from 'serp-search-bar';
import 'pch-events/common-events.js';

function checkNested(obj /*, level1, level2, ... levelN*/) {
    var args = Array.prototype.slice.call(arguments, 1);

    for (var i = 0; i < args.length; i++) {
        if (!obj || !obj.hasOwnProperty(args[i])) {
        return false;
        }
        obj = obj[args[i]];
    }
    return true;
}

decorateSearchBars(true);

if(window.PCHSW && window.PCHSW.search) {
    const pySerp = new PySerp(window.PCHSW.search, '[data-s1search="mainline"]');

    if(checkNested(PCHSW, 'search', 'invalidSearch')){
        if( !PCHSW.search.invalidSearch){
            pySerp.load()
        }
    }else{
        pySerp.load()
    }
    // ;
}

if(PCHSW.search && PCHSW.search.autoLaunchPanel && PCHSW.search.autoLaunchTimeout > 0 && PCHSW.search.autoLaunchUrl) {
    let timeout = PCHSW.search.autoLaunchTimeout;
    let url = PCHSW.search.autoLaunchUrl;
    setTimeout(() => {
        window.open(url, '_blank');
    }, timeout);

}

//Lightboxes
const displayQueue = new DisplayQueue();
const displayableFactory = new DisplayableFactory();
const displayableTemplates = document.querySelectorAll('[data-displayable]');
Array.from(displayableTemplates).forEach(dt => {

    const displayable = displayableFactory.getDisplayable(dt.dataset.displayable, {tmplElement: dt});

    displayQueue.enqueue(displayable.promise.bind(displayable));
});

if(PCH.uninav) {
    if(window.showComplPass) {
        displayQueue.enqueue(() => {
            const ssoLbClose = PCH.SsoLightbox.close;
            PCH.SsoLightbox.close = function close() {
                fetch('/closeCreatePasswordlb', { method: 'GET', credentials: 'include' })
                ssoLbClose(...arguments);
            };
            PCH.uninav.controller.triggerCompleteReg();
            return PCH.uninav.controller.onIdle();
        });
    }

    if(window.showComplReg) {
        displayQueue.enqueue(() => {
            const ssoLbClose = PCH.SsoLightbox.close;
            PCH.SsoLightbox.close = function close() {
                fetch('/closeCreatePasswordlb', { method: 'GET', credentials: 'include' })
                ssoLbClose(...arguments);
            };
            PCH.uninav.controller.searchContinueRegistration();
            return PCH.uninav.controller.onIdle();
        });
    }

    if(PCHUSER.isRecognizedUser) {
        displayQueue.enqueue(() => {
            PCH.uninav.controller.autoUpdate();
            return PCH.uninav.controller.onIdle();
        });
    }
}


window.addEventListener('DOMContentLoaded', function() {
    document.querySelector('[data-serp-search-bar-terms]').focus();
});

